export const ANALYTICS_EVENT_NAMES = {
  PAGE_VIEW: 'page_view',
  MODAL_VIEW: 'modal_view',
  CLICK: 'click',
  CAROUSEL_SLIDE: 'carousel_slide',
};
